module.exports = __webpack_public_path__ + "6f98b136d57330f2c4827021d6aa752d.png";